import { NavigationType } from 'src/api/contentful/contentTypes.cloverdotcom';
import { useContentfulNavigation } from './UseContentfulNavigation';

export function useContentfulNavBar() {

  const headerNavigation = useContentfulNavigation(NavigationType.HEADER, 3);
  const sidebarNavigation = useContentfulNavigation(NavigationType.SIDEBAR, 4);
  const headerUtilNavigation = useContentfulNavigation(NavigationType.HEADER_UTIL, 3);
  const sidebarHelpNavigation = useContentfulNavigation(NavigationType.SIDEBAR_SALES_HELP, 4);

  return {
    headerNavigation,
    sidebarNavigation,
    headerUtilNavigation,
    sidebarHelpNavigation,
  };
}
